import { useState } from "react";
import "./contactpage.css";


export default function ContactPage() {
    const [formData, setFormData] = useState({
      name: "",
      email: "",
      message: "",
      humanCheck: ""
    });
    const [emailSent, setEmailSent] = useState(false); // State to track email sent status
  
    const handleChange = (e: any) => {
      const { name, value } = e.target;
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        [name]: value,
      }));
    };
  
    const handleSubmit = async (e: any) => {
      e.preventDefault();
      if (formData.humanCheck !== "human") {
        alert("Please confirm that you are a human!");
        return;
      }
  
      // Send the email if the human check passes
      const response = await fetch("/sendmail.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });
  
      if (response.ok) {
        // If you want to use the result for something:
        // const result = await response.json();
        // console.log(result);
        setEmailSent(true);
        setTimeout(() => setEmailSent(false), 5000); // Hide message after 5 seconds
        setFormData({
          name: "",
          email: "",
          message: "",
          humanCheck: ""
        });
      } else {
        console.error("Failed to send email");
      }
    };
  
    return (
      <div>
        {emailSent && (
          <div className="toast-message">
            Your message has been sent successfully!
          </div>
        )}
        <header>
        <h1>Contact Us</h1>
        <p>If you have any questions, please fill out the form below to send us a message.</p>
      </header>
    <form onSubmit={handleSubmit}>
       <label htmlFor="name">Name</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
        <label htmlFor="humanCheck">Please select "I am a human"</label>
        <select
          name="humanCheck"
          id="humanCheck"
          value={formData.humanCheck}
          onChange={handleChange}
          required
        >
          <option value="">--Please choose an option--</option>
          <option value="robot">I am a robot</option>
          <option value="human">I am a human</option>
          <option value="swan">I am a peacock</option>
        </select>

        <button type="submit">Send Message</button>
      </form>
    </div>
  );
}